import type { z } from 'zod';

import type { LegacyExamMarkingRequestSchema } from './schemas';

type LegacyExamMarkingRequestField = keyof z.infer<typeof LegacyExamMarkingRequestSchema>;

const listAttributes = [
  'id',
  'creationDatetime',
  'dueDatetime',
  'examSubject',
  'examCode',
  'examId',
  'examLabel',
  'fileName',
  'markerId',
  'markerName',
  'status',
  'studentId',
  'studentName',
] as const satisfies readonly LegacyExamMarkingRequestField[];

const getAttributes = [...listAttributes] as const;

const updateAttributes = [
  'examSubject',
  'examCode',
  'examLabel',
  'markerId',
  'markerName',
  'studentId',
  'studentName',
  'dueDatetime',
  'status',
] as const satisfies readonly LegacyExamMarkingRequestField[];

export const LegacyExamMarkingRequestAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};

export const MAX_LEGACY_EXAM_SCAN_UPLOADS = 50;
